var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, CustomElement, html, ifDefined, nothing, Prop } from '@sick-davinci/ce-decorators';
import { IconRef } from '@sick-davinci/basic-elements';
import { style } from './Header.style';
import { SICK_LOGO } from '../assets/logo';
export
/**
 * The `davinci-core-header2` generates a DaVinci application-header
 *
 * @example
 * ```html
 * <davinci-core-header2 logo-title="Sick AG Waldkirch" app-name="Header2 Demo"></davinci-core-header2>
 * ```
 */
let Header2 = (_dec = Component({
  style: [style],
  tag: 'davinci-core-header2',
  dependencies: [IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = class Header2 extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "logo", _descriptor, this);

    _initializerDefineProperty(this, "logoTitle", _descriptor2, this);

    _initializerDefineProperty(this, "appName", _descriptor3, this);

    this.showDivider = () => {
      const childrenInMainSlot = Array.from(this.children).filter(child => !child.slot);
      return !!(this.appName && childrenInMainSlot.length);
    };
  }

  componentFirstRender() {
    this.observedElements = {
      header: this,
      left: this.shadowRoot.querySelector('.left'),
      right: this.shadowRoot.querySelector('.right')
    };
    Object.keys(this.observedElements).forEach(elementName => {
      new ResizeObserver(() => this._setAppNameVisibility()).observe(this.observedElements[elementName]);
    });
  }

  render() {
    return html`
      <div class="left">
        <slot name="left" @slotchange="${() => this.scheduleRender(true)}"></slot>
        ${this._renderLogo()}
      </div>
      <div class="right">
        <div class="app-name">${ifDefined(this.appName)}  ${this.showDivider() ? html`<hr>` : nothing}</div>
        <slot @slotchange="${() => this.scheduleRender(true)}"></slot>
      </div>
    `;
  }

  _renderLogo() {
    let logo = html`
      <div class="logo" title="${ifDefined(this.logoTitle)}">${SICK_LOGO}</div>
    `;

    if (this.logo) {
      logo = html`
        <img
          class="logo custom"
          src="${this.logo}"
          alt="${ifDefined(this.logoTitle)}"
          title="${ifDefined(this.logoTitle)}"
          }
        />
      `;
    }

    return logo;
  }

  _setAppNameVisibility() {
    const appNameEl = this.shadowRoot.querySelector('.app-name');
    const headerWidth = this.getBoundingClientRect().width - 20;
    const leftWidth = this.observedElements.left.getBoundingClientRect().width;
    const rightWidth = this.observedElements.right.getBoundingClientRect().width;
    headerWidth <= leftWidth + rightWidth ? appNameEl.classList.add('hidden') : appNameEl.classList.remove('hidden');
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "logo", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "logoTitle", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "appName", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
})), _class2)) || _class);
